import makeCrud from '@/store/site/localization/crud'

// Kayıt formu alanları (register-element) — bağımsız apiResource (kendi index'i var, sayfalı).
// create: POST {type_id, translate, options, sort, active}; put: PUT {translate, options, sort, active}.
export default makeCrud('system_setting_register_element')
